import React from 'react';
import { Input, Tooltip, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

const FormItem = Form.Item;

class FormCategoria extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        this.props.onSubmit({
          nombre: values.nombre,
          descripcion: values.descripcion,
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de la Categoria</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Nombre
                <Tooltip title="El nombre que se mostrara de la categoria ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('nombre')(<Input />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Descripcion
                <Tooltip title="Una breve descripcion de la categoria ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('descripcion')(<Input />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Siguiente
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      nombre: Form.createFormField({
        value: props.datos ? props.datos.nombre : '',
      }),
      descripcion: Form.createFormField({
        value: props.datos ? props.datos.descripcion : '',
      }),
    };
  },
})(FormCategoria);
